'use client'

import { createContext } from 'react'

import { TLocalizeVersion } from '@/app/constants'

export const LocalizeVersionContext = createContext<TLocalizeVersion | null>(null)

type TLocalizeVersionProviderProps = {
  value: TLocalizeVersion
  children: React.ReactNode
}

export function LocalizeVersionProvider({ value, children }: TLocalizeVersionProviderProps) {
  return <LocalizeVersionContext.Provider value={value}>{children}</LocalizeVersionContext.Provider>
}
